import { render, staticRenderFns } from "./RuleDetails.vue?vue&type=template&id=1cea6bf3&scoped=true&"
import script from "./RuleDetails.vue?vue&type=script&lang=js&"
export * from "./RuleDetails.vue?vue&type=script&lang=js&"
import style0 from "./RuleDetails.vue?vue&type=style&index=0&id=1cea6bf3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea6bf3",
  null
  
)

export default component.exports